import _ from "lodash";
import React, { useState, useRef } from "react";

import { connect } from "react-redux";

import { Modal, IconButton, SearchInput } from "@toddle-edu/ds-web";
import { TeacherAddOutlined } from "@toddle-edu/ds-icons";

import { handleRemoveUserFromChannel } from "MessagingV2/modules/MessagingModule";
import { useI18n } from "Hooks";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { isIdEqual } from "Utils";
import classes from "./ManageMembersTab.scss";
import { PARENT, STAFF, STUDENT } from "Constants/stringConstants";
import UsersList from "./components/UsersList";
import { CHAT_TYPE_ENUM } from "MessagingV2/modules/Utils";

const styles = {
  addMemberModalBodyStyles: {
    padding: "0px",
  },
  modalBodyStyles: {
    padding: "0px",
    overflow: "hidden",
  },
  searchOverlayContainerStyle: {
    maxHeight: "356px",
  },
  emptyStateSubtitleStyle: {
    width: "380px",
  },
  footerStyle: {
    padding: "8px 24px 4px",
  },
  dividerStyle: {
    margin: "4px 24px",
  },
};

const userTypeLabelsPlural = {
  [STUDENT]: "common:student_plural",
  [PARENT]: "common:family_member_plural",
  [STAFF]: "common:staff_members_plural",
};

const TAB_USER_TYPE_ORDER = [STAFF, STUDENT, PARENT];
const getUserTypeList = ({ users }) => {
  const usersByType = _.groupBy(users, "type");

  const userTypeList = _.reduce(
    TAB_USER_TYPE_ORDER,
    (acc, userType) => {
      if (usersByType[userType]) {
        acc[userType] = usersByType[userType];
      }
      return acc;
    },
    {}
  );

  return userTypeList;
};

const ManageMembersTab = props => {
  const {
    users,
    chatId,
    handleRemoveUserFromChannel,
    defaultStudentNameSortPreference,
    onAddMember,
    isMemberUpdate = true,
    showAddMemberButton,
    channelType,
  } = props;

  const { t } = useI18n(["common"]);
  const usersByType = getUserTypeList({ users });
  const containerRef = useRef(null);
  const [searchText, setSearchText] = useState("");

  const handleRemoveUser = async ({ user }) => {
    const updatedCurrentUsers = _.filter(users, u => {
      return !isIdEqual(user.id, u.id);
    });
    handleRemoveUserFromChannel({
      chatId,
      users: updatedCurrentUsers,
      removedUser: user,
    });
  };

  const hideStaffList = _.isEmpty(usersByType[STAFF]);
  const hideStudentList = _.isEmpty(usersByType[STUDENT]);
  const hideParentList = _.isEmpty(usersByType[PARENT]);

  const getSearchPlaceHolder = () => {
    switch (channelType) {
      case CHAT_TYPE_ENUM.CHANNEL_SYSTEM_MANAGED:
        return t("common:search_members_class_placeholder");
      case CHAT_TYPE_ENUM.CHANNEL_CUSTOM:
        return t("common:search_members_placeholder");
      case CHAT_TYPE_ENUM.CHANNEL_FAMILY:
        return t("common:search_members_family_placeholder");
    }
  };

  return (
    <Modal.Body style={styles.modalBodyStyles}>
      <div className={classes.addMemberAndSearchContainer}>
        <div className={classes.searchInputWrapper}>
          <SearchInput
            size="medium"
            value={searchText}
            onChange={setSearchText}
            variant={"outlined-subtle"}
            placeholder={getSearchPlaceHolder()}
            autoFocus
          />
        </div>
        {showAddMemberButton ? (
          <div className={classes.addMemberIconContainer}>
            <IconButton
              icon={<TeacherAddOutlined />}
              variant={"outlined-subtle"}
              onClick={onAddMember}
            />
          </div>
        ) : null}
      </div>
      <div ref={containerRef} className={classes.userListsWrapper}>
        {_.isEmpty(searchText) ? (
          <>
            {!hideStaffList ? (
              <div className={classes.userListsContainer}>
                <UsersList
                  headerTitle={t(userTypeLabelsPlural[STAFF])}
                  users={usersByType[STAFF]}
                  onRemoveClick={handleRemoveUser}
                  isMemberUpdate={isMemberUpdate}
                  defaultStudentNameSortPreference={
                    defaultStudentNameSortPreference
                  }
                  chatId={chatId}
                />
              </div>
            ) : null}
            {!hideStudentList ? (
              <div className={classes.userListsContainer}>
                <UsersList
                  headerTitle={t(userTypeLabelsPlural[STUDENT])}
                  users={usersByType[STUDENT]}
                  onRemoveClick={handleRemoveUser}
                  isMemberUpdate={isMemberUpdate}
                  defaultStudentNameSortPreference={
                    defaultStudentNameSortPreference
                  }
                  chatId={chatId}
                />{" "}
              </div>
            ) : null}
            {!hideParentList ? (
              <div className={classes.userListsContainer}>
                <UsersList
                  headerTitle={t(userTypeLabelsPlural[PARENT])}
                  users={usersByType[PARENT]}
                  onRemoveClick={handleRemoveUser}
                  isMemberUpdate={isMemberUpdate}
                  defaultStudentNameSortPreference={
                    defaultStudentNameSortPreference
                  }
                  chatId={chatId}
                />
              </div>
            ) : null}
          </>
        ) : (
          <UsersList
            containerRef={containerRef}
            searchText={searchText}
            onRemoveClick={handleRemoveUser}
            isMemberUpdate={isMemberUpdate}
            defaultStudentNameSortPreference={defaultStudentNameSortPreference}
            chatId={chatId}
          />
        )}
      </div>
    </Modal.Body>
  );
};

const mapActionCreators = {
  handleRemoveUserFromChannel,
  setToastMsg,
};

export default connect(null, mapActionCreators)(ManageMembersTab);
